import CardItemSwitch from 'components/card-item-switch/card-item-switch';

export default CardItemSwitch;
